<template>
  <v-container class="bg-white pa-0 policeLato" fluid pt-5>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
      <section>
        <div class="mt-5 paralax-cover-image has-background-dim">
          <p class="paralax-cover-image-text">
          <div class="content_home" style="z-index: 1!important;">
            <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">Devis <span style="color: #ffa409" class="ml-1">Santé</span> /</span></h1>
            <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">Packs Consultations</span></h1>
          </div>
          </p>
        </div>
      </section>

      <v-layout class="column">
        <v-layout style="background-color: #f5f6f6;">
          <v-flex xs12 style="padding-left: 8%;padding-right: 8%">
            <div class="justify-content-center row">
              <div class="pa-5 text-justify subheading font-weight-blod pl-md-5 pr-md-5" style="margin-bottom:-50px">
               <span class="headline" style="color: #ffa409"><i class="title-border policeLato"></i>Le meilleur pour votre santé au Sénégal <img
                   src="../../assets/img/flag_gif.gif" alt="senegal flag gif" width="22" style="margin-left:-2px;margin-top:-15px">, sans
                    bouger de chez nous!</span>

                <div class="container mt-4 mb-5">
                  <div class="justify-content-center row">
                    <div class="ml-3" style="width: 280px" v-for="pack in this.packObject" :key="pack">
                      <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);height: 100%!important">
                        <div class="healthCard-img">
                          <img src="../../assets/img/kermel/Pack cardio.png" alt="pack cardio" class="img-responsive" />
                        </div>
                        <div class="healthCard-text">
                          <div class="category">
                            <div class="button_redirect" style="color: #000">{{pack.pack_name}} <span style="color: #fff">{{ pack.mount }} FCFA/an</span></div>
                          </div>
                          <div class="description-prod" style="height: 100%!important">
                            <v-tabs color="#483D8B" dark slider-color="#fff" class="border-radius"
                                    style="margin-top:-20px">
                              <v-tab class="tab" ripple>Avantages</v-tab>
                              <v-tab class="tab" ripple>Conditions particulieres</v-tab>
                              <v-tab-item class="mt-4">
                                <div class="description-prod" v-for="benefit in pack.explications.benefits" :key="benefits">
                                  <p style="margin-top: -10px;">{{ benefit }}</p>
                                </div>
                              </v-tab-item>
                              <v-tab-item class="mt-4">
                                <div class="description-prod" v-for="terms in pack.explications.terms" :key="terms">
                                  <p style="margin-top: -10px;">{{ terms }}</p>
                                
                                 
                                  <!-- Pack valable un an pour une personne identifiée <br>
                                  Tarif annuel <br>
                                  Dossier médical numérisé mis à disposition pour tous les packs Kermel -->
                                </div>
                              </v-tab-item>
                            </v-tabs>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="ml-4" style="width: 280px">
                      <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);height: 100%!important">
                        <div class="healthCard-img">
                          <img src="../../assets/img/kermel/Pack_control_Diabète.jpg" alt="Product" class="img-responsive" />
                        </div>
                        <div class="healthCard-text">
                          <div class="category">
                            <div class="button_redirect" style="color: #000">Pack Diabète <span style="color: #fff">925 000 FCFA/an</span></div>
                          </div>
                          <div class="description-prod" style="height: 100%!important">
                            <v-tabs color="#483D8B" dark slider-color="#fff" class="border-radius"
                                    style="margin-top:-20px">
                              <v-tab class="tab" ripple>Avantages</v-tab>
                              <v-tab class="tab" ripple>Conditions particulieres</v-tab>
                              <v-tab-item>
                                <div class="description-prod">
                                  4 consultations de Diabetologie <br>
                                  1 consultation dentaire + détartrage <br>
                                  1 consultation de Cardiologie <br>
                                  1 ECG (électrocardiogramme) <br>
                                  1 EMG (électro myogramme) <br>
                                  1 Echo Doppler Axes Artériels (membres inférieurs et tronc supra-aortique)<br>
                                  Echo Doppler Cardiaque <br>
                                  1 MAPA (Mesure Ambulatoire Pression Artérielle) <br>
                                  1 biologie (glycémie *4, hémoglobine glyquée *4, bilan lipidique
                                  complet *2, fonctions rénales, protéinurie/micro albumine, bilan
                                  thyroïdien, uricémie) <br>
                                  1 fond d’œil (fait en externe) <br>
                                  Conseils diététiques et éducation thérapeutique <br>
                                  1 test d'effort
                                </div>
                              </v-tab-item>
                              <v-tab-item>
                                <div class="description-prod">
                                  Pack valable un an pour une personne identifiée <br>
                                  Tarif annuel <br>
                                  Dossier médical numérisé mis à disposition pour tous les packs Kermel <br>
                                  Glycémie tous les 3 mois <span style="font-size:10px">(4 fois/an au total)</span> <br>
                                  Hemoglobine glyquée tous les 3 mois <span style="font-size:10px">(4 fois/an au total)</span> <br>
                                  Bilan lipidique tous les 6 mois <span style="font-size:10px">(2 fois/an au total)</span>
                                </div>
                              </v-tab-item>
                            </v-tabs>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ml-4" style="width: 280px">
                      <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);height: 100%!important">
                        <div class="healthCard-img">
                          <img src="../../assets/img/kermel/Pack_remise.jpeg" alt="Product" class="img-responsive" style="height: 168px!important;"/>
                        </div>
                        <div class="healthCard-text">
                          <div class="category">
                            <div class="button_redirect" style="color: #000">Pack AVC <span style="color: #fff">725 000 FCFA/an</span></div>
                          </div>
                          <div class="description-prod" style="height: 100%!important">
                            <v-tabs color="#483D8B" dark slider-color="#fff" class="border-radius"
                                    style="margin-top:-20px">
                              <v-tab class="tab" ripple>Avantages</v-tab>
                              <v-tab class="tab" ripple>Conditions particulieres</v-tab>
                              <v-tab-item>
                                <div class="description-prod">
                                  4 consultations de Neurologie <br>
                                  2 consultations de Cardiologie <br>
                                  1 ECG (électrocardiogramme) <br>
                                  1 Holter ECG <br>
                                  1 EEG (électroencéphalogramme) <br>
                                  1 scanner ou IRM <br>
                                  1 Echo Doppler carotide <br>
                                  10 séances Kiné <br>
                                  Conseils diététiques et éducation thérapeutique <br>
                                  1 biologie facteurs de risques (glycémie, hémoglobine glyquée,
                                  fonctions rénales, bilan thyroïdien, bilan hépatite, créatinine,
                                  marqueurs cardiaques, bilan lipidique, protéinurie, uricémie)
                                </div>
                              </v-tab-item>
                              <v-tab-item>
                                <div class="description-prod">
                                  Pack valable un an pour une personne identifiée <br>
                                  Tarif annuel <br>
                                  IRM si nécessaire <br>
                                  Dossier médical numérisé mis à disposition pour tous les packs
                                  Kermel
                                </div>
                              </v-tab-item>
                            </v-tabs>
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <div class="wizard-card-footer clearfix mb-5 mt-5">
                    <div class="wizard-footer-left">
                    </div>
                    <div class="wizard-footer-right">
                      <button @click="dialog1=true" type="button" class="mt-4 wizard-btn">
                        Devis gratuit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-layout>

      <!-- =============== POPUP FORMULAIRE ================== -->
      <v-dialog v-model="dialog1" persistent max-width="800" v-if="isDesktop()">
        <v-card elevation="24" class="border-radius">

          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="choixAvance_desktop" aria-hidden="true" aria-labelledby="step-choixAvance_desktop" class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">Devis gratuit</div>
                      <div class="justify-content-center row">
                        <div class="col-sm-12">
                          <v-item-group class="mt-4">
                            <div class="justify-content-center row">
                              <p v-for="p in listPack" :key="p._id">
                                <v-checkbox v-if="p.nompack!='Option Dépistage Apnée Sommeil'" color="#483D8B"
                                            hide-details :label="p.nompack" true-value="1" false-value="0"
                                            @change="Checking(p.nompack)" :value="p"
                                            class="policeLato highlight pl-5" v-model="packChoisis"></v-checkbox>
                              </p>
                            </div>
                          </v-item-group>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-12">
                            <v-slide-y-transition slot="append" class="pt-3 justify-content-center row">
                              <v-layout row wrap justify-content-center justify-space-around v-if="optionCardio==true">
                                <v-flex class="ml-5" row wrap justify-content-center xs12 sm12 v-for="p in listPack" :key="p._id">
                                  <v-sheet v-if="p.nompack==='Option Dépistage Apnée Sommeil'" style="background:#FAFAFA">
                                    <v-switch style="background:#FAFAFA" class="policeLato" :value="p" v-model="packChoisis" inset
                                              :label="` Option Dépistage Apnée Sommeil (+100.000FCFA/an) ${switch1.toString()}`"></v-switch>
                                  </v-sheet>
                                </v-flex>
                              </v-layout>
                            </v-slide-y-transition>
                        </div>
                      </div>

                      <div class="justify-content-center row">
                        <div class="col-sm-12">
                          <div class="mt-4 justify-content-center row">
                            <div class="col-sm-4">
                              <div class="field-group field-default" style="margin-top:-2px">
                                <label for="Stepper25" class="field-label">
                                  Date d'effet
                                </label>
                                <div class="input-group value-loan">
                                  <date-picker class="field-input ml-2 mb-1 mt-1" :disabled-date="disabledBeforeToday" placeholder="Cliquer ici" id="Stepper25" @keyup="dateDiff" @change="dateDiff()" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="field-group field-default">
                                <label for="Stepper28" class="field-label">Date d'échéance</label>
                                <input v-model="dateEcheance" placeholder="Date d'échéance" id="Stepper28" name="Step8" disabled class="field-input">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="dialog1=false" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  Retour
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="SendNewData()" type="button" class="wizard-btn">
                  Continuer
                </button>
              </div>
            </div>
          </v-card-text>




          <!-- <v-flex justify-content-center row>
             <v-flex md8 ml-4 justify-content-center row>
               <v-radio-group v-model="packChoisis" row class="pl-2 justify-content-center row">
                 <p v-for="p in listPack" :key="p._id">
                   <v-radio
                       v-if="p.nompack!=='Option Dépistage Cancer/H' && p.nompack!=='Option Dépistage Cancer/F'"
                       color="#483D8B"
                       hide-details
                       :label="p.nompack"
                       true-value="1"
                       false-value="0"
                       :value="p"
                       class="policeLato highlight pt-2"
                       @change="Checking">
                   </v-radio>
                 </p>
               </v-radio-group>
             </v-flex>
           </v-flex>

           <v-flex class="justify-content-center row" v-show="optionPrevention==true">
             <p>
               <strong class="justify-content-center row mb-2 policeLato">Votre âge</strong>
               <span class="row policeLato">- 45 ans<v-switch class="ml-3 switch_age" v-model="age"
                                                              inset></v-switch>+ 45 ans</span>
             </p>
             <i class="title-border ml-5" v-show="testDialog"></i>
             <p class="ml-5" v-show="testDialog">
               <strong class="justify-content-center row mb-2 policeLato">Vous êtes</strong>
               <v-slide-y-transition slot="append" class="ml-5">
                 <v-flex class="justify-content-center row" v-show="testDialog">
                   <v-radio-group v-model="genre">
                     <v-tooltip top class="mr-5">
                       <template v-slot:activator="{ on }">
                         <v-radio v-on="on" class="policeLato" value="homme" color="#483D8B"
                                  label="Homme"></v-radio>
                       </template>
                       <span class="genre">Dépistage cancer inclus pour +45 ans <br>Coût supplémentaire 17 500 FCFA</span>
                     </v-tooltip>

                     <v-tooltip bottom class="mr-5">
                       <template v-slot:activator="{ on }">
                         <v-radio v-on="on" class="policeLato" value="femme" color="#483D8B"
                                  label="Femme"></v-radio>
                       </template>
                       <span class="genre">Dépistages cancers inclus pour +45 ans <br>Coût supplémentaire 57 500 FCFA</span>
                     </v-tooltip>
                   </v-radio-group>
                 </v-flex>
               </v-slide-y-transition>
             </p>
           </v-flex>

           <v-flex class="row">
             <v-flex>
               <v-flex justify-content-center row>
                 <v-flex md3 pl-4 ml-4>
                   <v-menu :close-on-content-click="false" v-model="datePickerEffet" lazy
                           transition="scale-transition" offset-y full-width min-width="290px">
                     <v-text-field slot="activator" @keyup="dateDiff"
                                   placeholder="Date de prise d'effet" v-model="dateEffet"
                                   prepend-inner-icon="event"></v-text-field>
                     <v-date-picker color="#ffa409" @change="dateDiff" v-model="dateEffet"
                                    @input="datePickerEffet = false"
                                    :min="new Date().toISOString().substr(0, 10)"
                                    locale="fr-fr"></v-date-picker>
                   </v-menu>
                 </v-flex>
                 <v-flex md3 pl-4 ml-4>
                   <v-text-field slot="activator" placeholder="Date d'échéance" v-model="dateEcheance"
                                 prepend-inner-icon="event" disabled></v-text-field>
                 </v-flex>
               </v-flex>
             </v-flex>
           </v-flex>

           <v-flex class="justify-content-center row">
             <v-btn round class="text-white font-weight-bold policeLato ml-5" color="#ffa409"
                    @click="SendNewData()"> Continuer
             </v-btn>
           </v-flex>-->
        </v-card>
      </v-dialog>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.sm.xs>
      <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
      <section>
        <div class="paralax-cover-image_mobile has-background-dim_mobile">
          <p class="paralax-cover-image-text_mobile">
          <div class="content_home" style="z-index: 1!important;margin-top: 10%">
            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">Devis <span style="color: #ffa409">Santé</span> /</span></h1>
            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>Pack Consultations</span></h1>
          </div>
          </p>
        </div>
      </section>

      <v-layout style="background-color: #f5f6f6;">
        <div class="pl-3 pr-3 pt-3 row">
          <div class="col-sm-11 pa-4 subheading font-weight-blod text-justify">
            <span class="headline" style="color: #ffa409"><i class="title-border policeLato"></i>Le meilleur pour votre santé au Sénégal <img
                src="../../assets/img/flag_gif.gif" alt="senegal flag gif" width="22" style="margin-left:-2px;margin-top:-15px">, sans
                    bouger de chez nous!</span>
          </div>
        </div>
      </v-layout>

      <v-layout style="background-color: #f5f6f6;">
        <div class="pb-5">

          <div class="container">
            <div class="justify-content-center row">
              <div class="col-md-3" v-for="pack in this.packObject" :key="pack">
                <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);height: 100%!important">
                  <div class="healthCard-img">
                    <img src="../../assets/img/kermel/Pack cardio.png" alt="pack cardio" class="img-responsive" />
                  </div>
                  <div class="healthCard-text">
                    <div class="category">
                      <div class="button_redirect" style="color: #000">{{pack.pack_name}} <span style="color: #fff">{{ pack.mount }} FCFA/an</span></div>
                    </div>
                    <div class="description-prod" style="height: 100%!important">
                      <v-tabs color="#483D8B" dark slider-color="#fff" class="border-radius"
                              style="margin-top:-20px">
                        <v-tab class="tab" ripple>Avantages</v-tab>
                        <v-tab class="tab" ripple>Conditions particulieres</v-tab>
                        <v-tab-item>
                          <div class="description-prod mt-3" v-for="benefit in pack.explications.benefits" :key="benefits">
                            <p>{{ benefit }}</p>
                          </div>
                        </v-tab-item>
                        <v-tab-item>
                          <div class="description-prod mt-3" v-for="terms in pack.explications.terms" :key="terms">
                            <p>{{ terms }}</p>
                          </div>
                        </v-tab-item>
                      </v-tabs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix mb-5 mt-5">
              <div class="wizard-footer-left">
              </div>
              <div class="wizard-footer-right">
                <button @click="dialog1=true" type="button" class="mt-5 wizard-btn">
                  Devis gratuit
                </button>
              </div>
            </div>
          </div>
        </div>
      </v-layout>

      <!-- =============== POPUP FORMULAIRE ================== -->
      <v-dialog v-model="dialog1" persistent max-width="800" v-if="isMobile()">
        <v-card elevation="24" class="border-radius">

          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="choixAvance_desktop" aria-hidden="true" aria-labelledby="step-choixAvance_desktop" class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">Devis gratuit</div>
                      <div class="justify-content-center row">
                        <div class="col-sm-12">
                          <v-item-group class="mt-4">
                            <div class="justify-content-center column">
                              <p v-for="p in listPack" :key="p._id">
                                <v-checkbox v-if="p.nompack!='Option Dépistage Apnée Sommeil'" color="#483D8B"
                                            hide-details :label="p.nompack" true-value="1" false-value="0"
                                            @change="Checking(p.nompack)" :value="p"
                                            class="policeLato highlight pl-5" v-model="packChoisis"></v-checkbox>
                              </p>
                            </div>
                          </v-item-group>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-12">
                          <v-slide-y-transition slot="append" class="pt-3 justify-content-center row">
                            <v-layout row wrap justify-content-center justify-space-around v-if="optionCardio==true">
                              <v-flex row wrap justify-content-center xs12 sm12 v-for="p in listPack" :key="p._id">
                                <v-sheet class="ml-5" v-if="p.nompack==='Option Dépistage Apnée Sommeil'" style="background:#FAFAFA">
                                  <v-switch style="background:#FAFAFA" class="policeLato" :value="p" v-model="packChoisis" inset
                                            :label="` Option Dépistage Apnée Sommeil (+100.000FCFA/an) ${switch1.toString()}`"></v-switch>
                                </v-sheet>
                              </v-flex>
                            </v-layout>
                          </v-slide-y-transition>
                        </div>
                      </div>

                      <div class="justify-content-center row">
                        <div class="col-sm-12">
                          <div class="mt-4 justify-content-center row">
                            <div class="col-sm-4">
                              <div class="field-group field-default" style="margin-top:-2px">
                                <label for="Stepper25" class="field-label">
                                  Date d'effet
                                </label>
                                <div class="input-group value-loan">
                                  <date-picker class="field-input ml-2 mb-1 mt-1" :disabled-date="disabledBeforeToday" placeholder="Cliquer ici" id="Stepper25" @keyup="dateDiff" @change="dateDiff()" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="field-group field-default">
                                <label for="Stepper28" class="field-label">Date d'échéance</label>
                                <input v-model="dateEcheance" placeholder="Date d'échéance" id="Stepper28" name="Step8" disabled class="field-input">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="dialog1=false" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  Retour
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="SendNewData()" type="button" class="wizard-btn">
                  Continuer
                </button>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import configPack from "../../common/packKermel"
import store from "../../store/store";
import Api from "../../services/Api";
import dayjs from 'dayjs'

export default {
  name: "Sante",
  data() {
    return {
      packObject : [],
      elevation: 2,
      switch1: '',
      switch2: '',
      sagefemme: false,
      btnnext: null,
      dialog1: false,
      dialog: false,
      showGoBtn: false,
      optionTitle1: null,
      optionTitle2: null,
      showLoginForm: false,
      Option: true,
      listPack: [],
      packChoisis: [],
      dateEffet: null,
      datePickerEffet: false,
      dateEcheance: null,
      optionCardio: false,
      optionDiabet: null,
      checkbox: false,
      payement: null,
      ToastTabSucess: { // Customized options for success toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 7000,
        fitToScreen: true,
        type: 'info',
        className: 'custom-success-class'
      },
      ToastTabError: { // Customized options for error toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 7000,
        fitToScreen: true,
        type: 'error'
      },
    }
  },
  metaInfo () {
    return {
      meta: [
        { charset: 'utf-8' },
        { name: 'keywords', content: 'description, assurance sante'},
        { hid: 'description', name: 'description', content: this.description}
      ]
    }
  },
  methods: {
    disabledBeforeToday(date) {
      const today = new Date();
      return date < today;
    },

    Checking(val) {
      let cpt = 0;

      if (val === 'Pack Cardio' || val.trim() === 'Pack Diabète') {

        for (let index = 0; index < this.packChoisis.length; index++) {
          if (this.packChoisis[index].nompack === 'Pack Cardio' || this.packChoisis[index].nompack.trim() === 'Pack Diabète') {
            cpt = cpt + 1
          }

        }

        if (cpt > 0) {
          this.optionCardio = true
        } else {
          this.optionCardio = false
        }

      }

    },

    getPackByPartenaire() {
      let p = {partenairename: 'KERMEL'};
      Api().post('packsante/partenairename/entreprise/', p)
          .then(resp => {
            this.listPack = resp.data.packs
          })
          .catch(err => {
            this.$toasted.show('Erreur de connexion', this.ToastTabError)
          })
    },

    dateDiff: function () {
      if (this.dateEffet === '' && this.duree === '') this.dateEcheance = '';
      let inter = dayjs(this.dateEffet).add(1, 'year').format('YYYY-MM-DD');
      this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
    },

    SendNewData: function () {
      if (!store.state.isUserLoggedIn) {
        this.showLoginForm = true
      } else if (store.state.isUserLoggedIn) {
        if (this.packChoisis.length > 0) {

          if (this.dateEffet) {

            const donnees = {
              branche: 'Santé',
              packChoisi: this.packChoisis,
              userid: store.state.user._id,
              createur: store.state.user._id,
              dateEffet: this.dateEffet,
              dateEcheance: this.dateEcheance,
              plateforme:"Front"
            };

            Api().post('devis/add', donnees)
                .then(resp => {
                  if (resp.data.message) {
                    this.$store.dispatch('setDevis', resp.data);
                    this.$router.push('/payement/nest')
                  }
                })
                .catch(e => {
                  this.$toasted.show("Ereur de connexion !", this.ToastTabError)
                })

          } else {
            this.$toasted.show("Date d'effet obligatoire !", this.ToastTabError)
          }

        } else {
          this.$toasted.show("Veuillez choisir au minimum 1 pack !", this.ToastTabError)
        }


      }

    },

    isMobile: function () {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },

    isDesktop: function () {
      if (screen.width > 760) {
        return true;
      } else {
        return false;
      }
    },

  },
  computed: {
    isDisabled: function () {
      return !this.sagefemme;
    },

  },
  mounted() {
    window.scrollTo(0, 0);
    this.getPackByPartenaire()
  },
  created() {
    this.packObject =  configPack;
  }
}
</script>

<style scoped>
.text-assuraf {
  color: #ffa409;
  /* font-family: Georgia !important; */
  font-weight: bold;
}

.tab {
  font-size: 10px
}

.title-border {
  border-left: 5px solid #ffa409;
  padding-left: 0.6em;
  line-height: 0.5em;
}

.georgia {
  font-family: Georgia !important;
}

.espace {
  line-height: 30px;
}



.texte {
  width: auto;
  font-family: Lato, "Helvetica Neue", Arial, sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.details {
  height: 36px;
  width: 120px;
  border-radius: 30px;
}

.text-assuraf {
  color: #ffa409;
}

.Assurance-AutoMoto {
  width: auto;
  height: 36px;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.border-radius {
  border-radius: 10px
}

.policeLato{
  font-family: Lato, "Helvetica Neue", Arial, sans-serif
}

















.expansion.expand-list{
  margin: 0;
  padding: 0;
}
.expansion.expand-list > li{
  list-style-type: none;
  padding: 15px 0;
  background-color: #fff;
  border-radius: 10px;
  position: relative;
  margin-top: 10%;
  /*         max-width: 80%; */
}
.expansion label[class^="tab"]:hover{
  cursor: pointer;
}
.expansion input{
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.expansion input[class^="tab"]{
  width: 100%;
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
}
.expansion input[class^="tab"]:hover{
  cursor: pointer;
}
.expansion label[class^="tab"]{
  font-weight: bold;
  font-size: 17px;
  margin-left: 3%;
}
.expansion .content{
  height: auto;
  max-height: 0;
  max-width: 400px;
  margin-left: 3%;
  font-weight: bold;
  /*        background: yellow;*/
  overflow: hidden;
  transform: translateY(20px);
  transition: all 180ms ease-in-out 0ms;
}
.expansion li[data-md-content="100"] input[class^="tab"]:checked ~ .content{
  max-height: 100px;
  transition: all 150ms ease-in-out 0ms;
}
.expansion li[data-md-content="200"] input[class^="tab"]:checked ~ .content{
  max-height: 200px;
  transition: all 200ms ease-in-out 0ms;
}
.expansion li[data-md-content="300"] input[class^="tab"]:checked ~ .content{
  max-height: 300px;
  transition: all 250ms ease-in-out 0ms;
}
.expansion li[data-md-content="400"] input[class^="tab"]:checked ~ .content{
  max-height: 400px;
  transition: all 250ms ease-in-out 0ms;
}
.expansion li[data-md-content="500"] input[class^="tab"]:checked ~ .content{
  max-height: 500px;
  transition: all 250ms ease-in-out 0ms;
}
.expansion li[data-md-content="600"] input[class^="tab"]:checked ~ .content{
  max-height: 600px;
  transition: all 250ms ease-in-out 0ms;
}
.expansion li[data-md-content="700"] input[class^="tab"]:checked ~ .content{
  max-height: 700px;
  transition: all 300ms ease-in-out 0ms;
}
.expansion li[data-md-content="800"] input[class^="tab"]:checked ~ .content{
  max-height: 800px;
  transition: all 300ms ease-in-out 0ms;
}
.expansion li[data-md-content="900"] input[class^="tab"]:checked ~ .content{
  max-height: 900px;
  transition: all 300ms ease-in-out 0ms;
}
.expansion li[data-md-content="1000"] input[class^="tab"]:checked ~ .content{
  max-height: 1000px;
  transition: all 350ms ease-in-out 0ms;
}
.expansion li[data-md-content=""] input[class^="tab"]:checked ~ .content{
  max-height: 1000px;
  transition: all 250ms ease-in-out 0ms;
}
.expansion input[class^="tab"]:checked ~ .content{
  margin-bottom: 20px;
}

.expansion .open-close-icon{
  display: inline-block;
  position: absolute;
  right: 20px;
  transform: translatey(2px);
}
.expansion .open-close-icon i{
  position: absolute;
  left: 0;
}
.expansion .open-close-icon .fa-chevron-up{
  transform:rotate(-180deg);
  transition: transform 150ms ease-in-out 0ms;
}
.expansion input[class^="tab"]:checked ~ .open-close-icon .fa-chevron-up{
  opacity: 1;
  transform: rotate(0deg);
  transition: transform 150ms ease-in-out 0ms;
}
.expansion .open-close-icon .fa-chevron-down{
  opacity: 0;
  transform:rotate(-90deg);
  transition: opacity 50ms linear 0ms, transform 150ms ease-in-out 0ms;
}
.expansion input[class^="tab"]:checked ~ .open-close-icon .fa-chevron-down{
  opacity: 0;
  transform: rotate(0deg);
  transition: opacity 50ms linear 0ms, transform 150ms ease-in-out 0ms;
}




.trigger_auto{
  width: 300px;
}
.trigger_auto span {
  width: 300px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}


.newsletter span{
  width: 200px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  text-transform: none;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border: 2px solid #000000;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}
.newsletter:hover span {
  /*min-width: 220px;*/
  border-radius: 10px;
  border: none;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #000000;
  background: #ffa409;
}


input[type="email"]{
  background: rgba(255, 255, 255, 0.1);
  border: none;
  font-size: 16px;
  height: auto;
  margin: 0;
  outline: 0;
  padding: 15px;
  width: 300px;
  background-color: rgba(115, 115, 115, 0.58);
  color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
  margin-bottom: 30px;
}
input[type="email"]::placeholder{
  color: #fff;
  font-size: 20px;
}



.trigger{
  width: 220px;
}
.trigger span {
  width: 220px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}
.trigger ul.devis li {
  top: 0;
  left: 0;
  width: 220px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}
.trigger ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right,#eee,#fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}
.trigger ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}
.trigger ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}
.trigger ul.devis li:hover {
  border-left: 10px solid #eee;
}
.trigger:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}
.watch_video:hover span {
  border-radius: 10px;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #000000;
  background: #ffa409;
}

.trigger:hover ul.devis {
  transform: scaley(1);
}
.trigger:hover ul.devis a {
  opacity: 1;
}



.trigger_auto_mobile{
  width: auto;
}
.trigger_auto_mobile span {
  width: auto;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.newsletter span{
  width: 200px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  text-transform: none;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border: 2px solid #000000;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}
.newsletter:hover span {
  border-radius: 10px;
  border: none;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #000000;
  background: #ffa409;
}







.paralax-cover-image {
  background-image: url('../../assets/img/assurance/kermel.jpg');
  position: relative;
  background-size: contain!important;
  background-position: 50%;
  min-height: 210px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image {
  background-attachment: fixed;
  background-position: 50% 50px;
}



.paralax-cover-image_mobile {
  background-image: url('../../assets/img/assurance/kermel_mobile.jpg');
  position: relative;
  background-size: contain;
  background-position: 50%;
  min-height: 150px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image_mobile p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  padding-bottom: 20Px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image_mobile {
  /* background-attachment: fixed; */
  background-position: 100% 40px;
}


.hero {
  position: relative;
  background-size: cover;
  background-position: center center;
  height: 680px;
  min-height: 320px;
  max-height: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-pack: center;
  padding: 20px;
}
.hero .content_home {
  position: relative;
  min-height: 280px;
  width: 100%;
  margin-left: 8.5%;
  z-index: 2;
  /*//background: red;*/
}
.hero .content_home p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.healthCard-product{
  background:#fff;
  padding:15px;
  border-radius:6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  position:relative;
  margin:20px auto;
}
.healthCard-img{
  position:absolute;
  top:5px;
  left:50%;
  transform:translate(-50%);
  -webkit-transform:translate(-50%);
  -ms-transform:translate(-50%);
  -moz-transform:translate(-50%);
  -o-transform:translate(-50%);
  -khtml-transform:translate(-50%);
  width: 100%;
  padding: 15px;
  transition: all 0.2s ease-in-out;
}
.healthCard-img img{
  width:100%;
  transition: all 0.2s ease-in-out;
  border-radius:6px;
}
.healthCard-text{
  padding-top:68%;
}
.healthCard-text .category{
  text-align:center;
  font-size:12px;
  font-weight:bold;
  padding:5px;
  margin-bottom:45px;
  position:relative;
  transition: all 0.2s ease-in-out;
}
.healthCard-text .category > *{
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  -webkit-transform: translate(-50%,-50%);
  -moz-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  -o-transform: translate(-50%,-50%);
  -khtml-transform: translate(-50%,-50%);

}
.healthCard-text .category > span{
  width: max-content;
  padding: 12px 30px;
  border: 1px solid #ffa409;
  background:#ffa409;
  color:#fff;
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  border-radius:27px;
  transition: all 0.05s ease-in-out;

}
.healthCard-text .category > .button_redirect {
  width: -webkit-max-content!important;
  display: inline-block!important;
  padding: 12px 30px;
  border: 1px solid #ffa409;
  background:#ffa409;
  color:#fff;
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  border-radius:27px;
  transition: all 0.05s ease-in-out;
}

.healthCard-text .category > .button_redirect_disabled {
  width: -webkit-max-content!important;
  display: inline-block!important;
  padding: 12px 30px;
  border: 1px solid #59595B;
  background:#59595B;
  color:#fff;
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  border-radius:27px;
  transition: all 0.05s ease-in-out;
}

.healthCard-product:hover .healthCard-text .category > span{
  border-color:#ddd;
  box-shadow: none;
  padding: 11px 28px;
}
.healthCard-text .title-product h3{
  font-size:20px;
  font-weight:bold;
  margin:15px auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width:100%;
}
.healthCard-text .description-prod p{
  margin:0;
}
.healthCard-text .description-prod {
  width: 100%;
/* height:130px; */
  font-size: 14px;
  /* -webkit-line-clamp: 3; */
  -webkit-box-orient: vertical;
  margin-bottom:15px;
}

@media screen and (max-width: 991px) {
  .healthCard-product{
    margin:40px auto;
  }
  .healthCard-product .healthCard-img{
    top:-40px;
  }
  .healthCard-product .healthCard-img img{
    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  }
  .healthCard-product .healthCard-text .category > span{
    border-color:#ddd;
    box-shadow: none;
    padding: 11px 28px;
  }
  .healthCard-product .healthCard-text .category{
    margin-top: -55px;
  }
}
</style>
